module.exports = __webpack_public_path__ + "img/fish.ff24278a.png";